import { createApp, watch } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import i18n from './i18n'
import axios from 'axios'
import { SecureStorage } from '@/utils/storage'
import { harden } from '@/utils/security'

import 'mdb-vue-ui-kit/css/mdb.min.css'
import './index.css'

// Suppress ALL console output — no app info ever leaked
const noop = () => {};
console.log = noop;
console.debug = noop;
console.info = noop;
console.warn = noop;
console.error = noop;
console.trace = noop;
console.table = noop;
console.group = noop;
console.groupEnd = noop;
console.dir = noop;
console.dirxml = noop;
console.assert = noop;
console.count = noop;
console.time = noop;
console.timeEnd = noop;


// Load Font Awesome from CDN (npm import removed — production builds had font-file path issues)
(function() {
  if (!document.querySelector('link[href*="font-awesome"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    link.crossOrigin = 'anonymous';
    link.referrerPolicy = 'no-referrer';
    document.head.appendChild(link);
  }
})();

// Set favicon
(function() {
  let existing = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
  if (existing) {
    existing.href = '/img/icons/favicon.ico';
  } else {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = '/img/icons/favicon.ico';
    document.head.appendChild(link);
  }
})();

harden();

if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  ['log', 'debug', 'info', 'warn', 'error', 'trace', 'dir', 'table', 'group', 'groupEnd', 'groupCollapsed', 'time', 'timeEnd'].forEach(method => {
    window.console[method] = noop;
  });
}

SecureStorage.clearExpired();

try {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key !== 'user-language') {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
} catch {
  // silent
}

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
});

apiClient.interceptors.request.use(
  (config) => {
    const existing = config.headers?.['Accept-Language'] || config.headers?.['accept-language'];
    if (!existing) {
      const activeLanguage = i18n.global.locale.value || 'en';
      config.headers['Accept-Language'] = activeLanguage;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const app = createApp(App);

app.use(pinia);
app.use(i18n);
app.use(router);

app.provide('api', apiClient);

watch(
  () => i18n.global.locale.value,
  (newLang) => {
    const lang = newLang || 'en';
    localStorage.setItem('user-language', lang);
  }
);

app.mount('#app');